module.exports = __webpack_public_path__ + "Roboto-Bold.dc81817def276b4f2139.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.woff
// module id = 299
// module chunks = 2